import { createBrowserRouter } from 'react-router';
import { Layout } from './components/Layout/layout.component';
import { lazy } from 'react';
import { pageLoader } from './queries/page.query';
import { queryClient } from './consts/client.const';
import { PAGE_SLUG } from './app.type';
import { vehicleLoader } from './queries/vehicle.query';
import { Fallback } from './components/Fallback/fallback.component';
import { ErrorBoundary } from './components/ErrorBoundary/error-boundary.component';
import { settingsLoader } from './queries/settings.query';
import * as Sentry from '@sentry/react';

const Home = lazy(() => import('./pages/Home/home.component'));
const Contact = lazy(() => import('./pages/Contact/contact.component'));
const CookiePolicy = lazy(
  () => import('./pages/CookiePolicy/cookie-policy.component'),
);
const LeaseTerms = lazy(
  () => import('./pages/LeaseTerms/lease-terms.component'),
);
const NotFound = lazy(() => import('./pages/NotFound/not-found.component'));
const PriceList = lazy(() => import('./pages/PriceList/price-list.component'));
const Services = lazy(() => import('./pages/Services/services.component'));
const Vehicles = lazy(() => import('./pages/Vehicles/vehicles.component'));
const Vehicle = lazy(() => import('./pages/Vehicle/vehicle.component'));

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

export const router = sentryCreateBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <ErrorBoundary />,
    hydrateFallbackElement: <Fallback />,
    loader: settingsLoader(queryClient),
    children: [
      {
        index: true,
        element: <Home />,
        loader: pageLoader(queryClient, PAGE_SLUG.HOME),
      },
      {
        path: 'warunki-wynajmu',
        element: <LeaseTerms />,
        loader: pageLoader(queryClient, PAGE_SLUG.LEASE_TERMS),
      },
      {
        path: 'cennik',
        element: <PriceList />,
        loader: pageLoader(queryClient, PAGE_SLUG.PRICE_LIST),
      },
      {
        path: 'samochody',
        children: [
          {
            index: true,
            element: <Vehicles />,
            loader: pageLoader(queryClient, PAGE_SLUG.VEHICLES),
          },
          {
            path: ':vehicleId',
            element: <Vehicle />,
            loader: vehicleLoader(queryClient),
          },
        ],
      },
      {
        path: 'uslugi',
        element: <Services />,
        loader: pageLoader(queryClient, PAGE_SLUG.SERVICES),
      },
      {
        path: 'kontakt',
        element: <Contact />,
        loader: pageLoader(queryClient, PAGE_SLUG.CONTACT),
      },
      {
        path: 'polityka-prywatnosci',
        element: <CookiePolicy />,
        loader: pageLoader(queryClient, PAGE_SLUG.CONTACT),
      },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
